import {
  collection,
  getDocs,
  limit as fbLimit,
  orderBy,
  query,
  where,
  type Firestore,
} from 'firebase/firestore';
import type { BillingCharge } from '@kawai/shared';
import { db as defaultDb } from '../firebase.js';

/** S-90: ホームの請求履歴サマリーに出す件数（直近 3 件）。 */
export const RECENT_BILLING_CHARGES_LIMIT = 3;

/**
 * S-90: 自テナントの請求履歴（billing_charges）を新しい順に取得する。
 * saas-admin の `fetchBillingChargesByTenant`（TP-25）を tenant-portal 向けに移植した
 * read 専用 repository（ホームのお支払いサマリー用のため limit 付き）。
 *
 * - Firestore Rules: read は `isAdmin() && belongsToMyTenant()` — テナント管理者は
 *   自テナント分を読める（rules 変更不要）
 * - composite index `(tenantId ASC, createdAt DESC)` は配備済み（firestore.indexes.json）
 * - 引数 `db` はテスト時に Firestore モックを注入するため optional
 */
export async function fetchRecentBillingCharges(
  tenantId: string,
  limitCount: number = RECENT_BILLING_CHARGES_LIMIT,
  db: Firestore = defaultDb,
): Promise<BillingCharge[]> {
  const snap = await getDocs(
    query(
      collection(db, 'billing_charges'),
      where('tenantId', '==', tenantId),
      orderBy('createdAt', 'desc'),
      fbLimit(limitCount),
    ),
  );
  return snap.docs.map((d) => ({
    ...(d.data() as Omit<BillingCharge, 'id'>),
    // doc id を真実源にする（data.id と一致するが防御的に上書き）。
    id: d.id,
  }));
}
